import axios from 'axios'
import Cookies from 'js-cookie'
import flash, {showResponseMessage} from 'util/flash/Flash'
import {toastify} from 'util/toast/Toast'


export const BASE_URL =
    window.Cypress || process.env.REACT_APP_USE_TEST_API
    ? 'http://code.dev.com:5001/api'
    : process.env.NODE_ENV === 'development'
    ? 'http://code.dev.com:5000/api'
    : process.env.NODE_ENV === 'production'
    && 'https://bluelightstudio.net/api'


class REST {
    requestURL = route => `${BASE_URL}/${route}`

    defaultHeaders = () => ({
        'Access-Control-Allow-Credentials': true,
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
        'Access-Control-Allow-Headers': [
            'Content-Type',
            'Set-Cookie',
            'X-CSRF-TOKEN',
            'Accept',
            'Authorization',
            'Origin',
        ],
        'Access-Control-Allow-Origin': [BASE_URL],
        'Content-type': 'application/json; charset=utf-8',
        'X-CSRF-TOKEN': Cookies.get('csrf_access_token'),
    })

    async GET(route, payload=null, url=null) {
        try {
            return await axios({
                method: 'get',
                url: url || this.requestURL(route),
                params: payload,
                withCredentials: true,
                withXSRFToken: true,
                headers: this.defaultHeaders(),
            })
            .then(response => this.handleFlaskResponse(response, payload))
        }
        catch (error) {
            this.handleFlaskResponse(error.response)
        }
    }

    async POST(route, payload=null, url=null) {
        try {
            return await axios({
                method: 'post',
                url: url || this.requestURL(route),
                data: payload,
                withCredentials: true,
                withXSRFToken: true,
                headers: this.defaultHeaders(),
            })
            .then(response => this.handleFlaskResponse(response, payload))
        }
        catch (error) {
            this.handleFlaskResponse(error.response)
        }
    }

    handleFlaskResponse(response, payload=null) {
        // if the server reset access control, request again with new credentials
        if (response?.data?.resend) {
            if (response.config.method === 'get') {
                return this.GET('', payload, response.config.url)
                .then(response => response)
            }

            if (response.config.method === 'post') {
                return this.POST('', payload, response.config.url)
                .then(response => response)
            }
        }

        let notifications = this.handleServerNotifications(response)

        if (notifications) {
            return notifications
        }

        this.handleRedirect(response, payload)

        return response
    }

    handleRedirect(response, payload=null) {
        if (response?.data?.next) {
            if (response.data.next === 'reload') {
                return window.location.reload()
            }

            window.location = response.data.next
        }
    }

    handleServerNotifications(response) {
        // display any notifications returned from flask
        if (response?.data?.msg) {
            showResponseMessage(response, this.handleRedirect)
            return response
        }

        if (response?.data?.flash) {
            flash(response, this.handleRedirect)
            return response
        }

        if (response?.data?.toast) {
            toastify(response)
        }

        return null
    }
}

export default REST
